import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ToiletWheelchair = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="toilet-wheelchair"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.9 17.855a4.928 4.928 0 10-4.928-4.927 4.928 4.928 0 004.928 4.927zM32.513 45.775c-1.309 4.546-5.5 7.885-10.462 7.885-6.01 0-10.896-4.887-10.896-10.894 0-4.447 2.683-8.275 6.511-9.966v-4.618c-6.27 1.888-10.85 7.708-10.85 14.584C6.816 51.166 13.65 58 22.05 58c6.122 0 11.399-3.639 13.818-8.86l-1.72-3.38-1.636.015z" />
      <path d="M46.869 51.624l-6.6-12.976a2.89 2.89 0 00-2.578-1.582h-8.453V35.14h7.275c.727 0 1.337-.38 1.732-.927.256-.356.438-.77.438-1.243a2.17 2.17 0 00-2.17-2.17h-7.275V24.26c0-1.798-1.333-4.34-4.338-4.34a4.34 4.34 0 00-4.34 4.34v14.165a4.427 4.427 0 004.427 4.427h10.93l5.796 11.394a2.891 2.891 0 003.89 1.267 2.89 2.89 0 001.266-3.89zM47.665 4.14h1.905L46.285 12h-1.68l-1.32-3.375L41.995 12H40.3l-3.27-7.86h1.89l2.34 5.94.915-2.565-1.365-3.36h1.665l.81 2.4.825-2.4h1.665l-1.365 3.36.93 2.565 2.325-5.94zm6.23 8.01c-.64 0-1.216-.105-1.726-.315-.51-.22-.945-.52-1.305-.9a4.36 4.36 0 01-.84-1.32 4.236 4.236 0 01-.285-1.545c0-.74.165-1.415.495-2.025.34-.62.82-1.115 1.44-1.485.62-.37 1.355-.555 2.205-.555.85 0 1.58.185 2.19.555.61.37 1.065.855 1.365 1.455l-1.965.6c-.17-.29-.395-.51-.675-.66-.28-.16-.59-.24-.93-.24A1.974 1.974 0 0052.08 6.84c-.18.35-.27.76-.27 1.23 0 .46.09.87.27 1.23.19.35.44.63.75.84.31.2.655.3 1.035.3.24 0 .465-.04.675-.12.22-.08.415-.19.585-.33.17-.14.295-.3.375-.48l1.965.6c-.18.39-.445.74-.795 1.05-.34.31-.745.555-1.215.735-.46.17-.98.255-1.56.255z" />
    </svg>
  );
};
/* eslint-enable max-len */

ToiletWheelchair.defaultProps = {
  className: null,
};

ToiletWheelchair.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ToiletWheelchair;
